import React, { useState } from 'react';
import { historyPropType } from '~/config/routerPropTypes';
import { createAddon, showAddon } from '~/config/routes';
import Request     from '~/providers/Request';
import AddonRecord from '~/records/AddonRecord';
import Form        from './Form';

function NewRecord({history}){
  const [record, setRecord] = useState(new AddonRecord());
  const [ loading, setLoading] = useState(false);

  async function onSubmit (saveAndContinue){
    const data = record.toParams();
    setLoading(true);
    Request.post('/admin/packages', data, {}, { controller: 'addon' })
    .then((resp) => {
      setLoading(false);
      if(saveAndContinue){
        history.push(createAddon.spec);
      } else{
        history.push(showAddon.reverse(resp.data));
      }
    }).catch( (err) => {
      console.error(err);
      setLoading(false);
    } );
  }

  const handleChange = (attrs) => {
    setRecord( record.updateAttributes(attrs) );
  };

  return(
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
    />
  );
}

NewRecord.propTypes={
  history: historyPropType,
};

export default NewRecord;
